module.exports = __webpack_public_path__ + "static/sabby-illustration-008a34422547e46d5f5a26983f0f49fa.png";